import { ProjectedTaskDetail, TemplateJobProjectionResponse } from "../../interfaces/adminUser/adminRecurringTaskStats/AdminRecurringTaskJobStats";

/**
 * Fetches the "Dry Run" calendar projection for a specific Organization, Year, and Month.
 */
export const getMonthlyProjections = async (
    authToken: string, 
    organizationId: number, 
    year: number, 
    month: number
): Promise<TemplateJobProjectionResponse | null> => {
    try {
        const response = await fetch(`${process.env.REACT_APP_API_BASE_URL}/admin/template-stats/projection/${organizationId}/${year}/${month}`, {
            method: 'GET',
            headers: {
                'Authorization': `Bearer ${authToken}`,
                'Content-Type': 'application/json'
            },
        });

        if (!response.ok) {
            console.error("Failed to fetch monthly projections:", response.status, response.statusText);
            return null;
        }

        return await response.json();
    } catch (error) {
        console.error("Error fetching monthly projections:", error);
        return null;
    }
};

/**
 * Checks for tasks that *should* have been created in the past X days but were missed.
 */
export const getRetroactiveMissedTasks = async (
    authToken: string, 
    organizationId: number, 
    lookbackDays: number = 90
): Promise<ProjectedTaskDetail[] | null> => {
    try {
        const queryParams = new URLSearchParams({
            lookbackDays: lookbackDays.toString()
        });

        const response = await fetch(`${process.env.REACT_APP_API_BASE_URL}/admin/template-stats/missed/${organizationId}?${queryParams}`, {
            method: 'GET',
            headers: {
                'Authorization': `Bearer ${authToken}`,
                'Content-Type': 'application/json'
            },
        });

        if (!response.ok) {
            console.error("Failed to fetch retroactive missed tasks:", response.status, response.statusText);
            return null;
        }

        return await response.json();
    } catch (error) {
        console.error("Error fetching retroactive missed tasks:", error);
        return null;
    }
};